<template>
  <v-card class="card-wrap" :height="height">
    <v-card-title v-if="title">{{ $t('abapdump.message.title') }}</v-card-title>
    <v-card-text>
      <v-row>
        <v-col cols="6">
          <v-row>
            <v-col cols="3"><p class="label">Category</p></v-col>
            <v-col cols="9"><v-text-field :value="dumpData.category" outlined dense hide-details readonly></v-text-field></v-col>
          </v-row>
          <v-row>
            <v-col cols="3"><p class="label">Runtime Errors</p></v-col>
            <v-col cols="9"><v-text-field :value="dumpData.dumpId" outlined dense hide-details readonly></v-text-field></v-col>
          </v-row>
        </v-col>
        <v-col cols="6">
          <v-row>
            <v-col cols="3"><p class="label">Except.</p></v-col>
            <v-col cols="9"><v-text-field :value="dumpData.exNm" outlined dense hide-details readonly></v-text-field></v-col>
          </v-row>
          <v-row>
            <v-col cols="3"><p class="label">Date and Time</p></v-col>
            <v-col cols="9"><v-text-field :value="dumpData.sapYmdhms | format('yyyy-MM-dd HH:mm:ss')" outlined dense hide-details readonly></v-text-field></v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card-text>
    <div class="card-inner-div" :style="forceHeight">
      <v-expansion-panels v-model="panel" accordion multiple hover tile readonly>
        <v-expansion-panel v-for="(msg, i) in dumpMsgs" :key="i">
          <v-expansion-panel-header :id="msg.category" @click="togglePanel(i)">{{ msg.category }}</v-expansion-panel-header>
          <v-expansion-panel-content class="msg-cntt" v-html="msg.content"></v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
  </v-card>
</template>

<script>
import { api } from '@/api/common/instances';

export default {
  props: {
    title: {
      type: Boolean,
      default: true,
    },
    height: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      dumpData: {},
      dumpMsgs: [],
      panel: [],
    };
  },
  computed: {
    forceHeight() {
      return `height: ${this.height - 140}px`;
    },
  },
  methods: {
    // Grid 내역 재조회가 발생한 경우 부모 컴포넌트가 호출해주면 하면 메시지를 제거해준다.
    removeDumpMessage() {
      this.dumpData = {};
      this.dumpMsgs = [];
    },
    // Grid 내역이 선택된 경우 부모 컴포넌트가 호출해주면 상세 메시지를 조회한다.
    async getDumpMessage(item) {
      const { data } = await api.get('/detailview/abapdump/message', {
        params: {
          svrYmdhms: item.svrYmdhms,
          sapYmdhms: item.sapYmdhms,
          sstmId: item.sstmId,
          ahost: item.ahost,
          dumpId: item.dumpId,
          modno: item.modno,
        },
      });
      this.dumpData = data;
      this.dumpMsgs = data.parsedMessage;
      this.panel = [0];
    },
    /**
     * v-expansion-panels의 Props readonly를 지정한 경우에는
     * 패널의 open/close를 위해서는 v-expansion-panels의 value를 조정해 주어야 한다.
     * 반대로 readonly를 지정하지 않은 경우에는 자기가 알아서 하므로
     * value를 조정하면 오동작이 발생한다.
     */
    togglePanel(idx) {
      const foundIdx = this.panel.findIndex(p => p == idx);
      if (foundIdx == -1) this.panel.push(idx);
      else this.panel.splice(foundIdx, 1);
    },
  },
};
</script>

<style scoped>
.card-inner-div {
  overflow: auto;
}
.label {
  text-align: right;
  padding-right: 15px;
}
.msg-cntt {
  margin-left: 20px;
}
</style>
